import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import SellerCard from '../../components/admin/SellerCard';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import EmptyState from '../../components/common/EmptyState';
import { useToast } from '../../components/common/Toast';
import { adminService } from '../../services/admin.service';
import { theme } from '../../config/theme';
import { InboxIcon } from '../../components/icons/Icons';

const PendingSellers = () => {
  const toast = useToast();
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    fetchPendingSellers();
  }, []);

  const fetchPendingSellers = async (page = 1) => {
    setLoading(true);
    try {
      const response = await adminService.getPendingSellers(page);
      setSellers(response.data?.data || []);
      setPagination(response.data?.data?.pagination || null);
    } catch (error) {
      toast.error('Failed to load pending sellers');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner fullScreen />;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl }}>
        <div style={{ marginBottom: theme.spacing.xl }}>
          <h1 style={{ fontSize: theme.typography.fontSize['3xl'], fontWeight: theme.typography.fontWeight.bold, marginBottom: theme.spacing.xs }}>
            Pending Seller Applications
          </h1>
          <p style={{ color: theme.colors.text.secondary }}>
            {pagination?.total || 0} applications awaiting review
          </p>
        </div>

        {sellers.length === 0 ? (
          <EmptyState 
            icon={<InboxIcon size={48} />}
            title="No pending applications" 
            description="All applications have been reviewed" 
          />
        ) : (
          <div style={{ display: 'grid', gap: theme.spacing.md }}>
            {sellers.map(seller => <SellerCard key={seller.id} seller={seller} />)}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default PendingSellers;